import React from "react";
import { useQuery } from "@tanstack/react-query"
import NotAvailable from 'components/common/NotAvailable'
import Loader from 'components/general/Loader';
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import MirsTable from "components/general/table/Table";
import { getCurrentBySubcode, getEvents } from "data/Querys";
import { RSC_SIZE } from "helpers/rsc"
import SportCode from "components/common/SportCode";
import DateTime from "components/presentation/DateTime";
import useViewport from "components/general/useViewPort";
import { getDateTimeFormat } from "helpers/utils";

function getColumn({
  id = '',
  header = '',
  code = '',
  headerClassName = 'text-start',
  className = 'text-start',
  columnIndex = '',
  eventsData = {}
}) {
  return (
    {
      id: id,
      Header: <Label data={header} />,
      headerClassName: headerClassName,
      className: className,
      columnIndex: columnIndex,
      isVisible: false,
      Cell: (props) => {
        let row = props.cell.row.original
        let val = row?.extensions.find(e => e.eie_code === code)?.eie_value
        let out = ''
        switch (code) {
          case 'EVENT':
            out = eventsData?.events?.find(e => row?.ei_value.includes(e.code))?.longDescription || row?.ei_value
            break;
          case 'STATUS':
            out = <SportCode code={val} discipline="SAL" entity="@Status" />
            break;
          default:
            out = val
            break;
        }
        return (
          out
        )
      }
    }
  )
}

const CompetitionStatus = () => {
  const { breakPoint } = useViewport();
  const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
  let _longDiscipline = mirs_discipline.padEnd(RSC_SIZE.FULL, '-')
  const { data: currentData, isError: currentError, isLoading: currentLoading } = useQuery(
    {
      queryKey: ['current', mirs_competition, mirs_language, _longDiscipline, 'STATUS'],
      queryFn: getCurrentBySubcode,
      refetchInterval: 10000,
    }
  )

  const { data: eventsData, isError: eventsError, isLoading: eventsLoading } = useQuery(
    {
      queryKey: ['events', mirs_competition, mirs_discipline, mirs_language],
      queryFn: getEvents,
      refetchInterval: 350000,
      staleTime: 350000,
    }
  )

  const isLoading = currentLoading || eventsLoading
  const isError = currentError || eventsError

  if (isError) { return <NotAvailable label={'LabelNoDataDailyComponent'} /> }
  if (isLoading) { return <Loader /> }

  const tableColumns = ([
    //getColumn({ id: 'event', header: 'HeaderEvent', code: 'EVENT', eventsData: eventsData, columnIndex: 1 }),
    {
      id: 'event',
      Header: <Label data={'HeaderEvent'} />,
      className: 'text-start',
      headerClassName: 'text-start',
      Cell: (props) => {
        let row = props.cell.row.original
        let out = eventsData?.events?.find(e => row?.ei_value.includes(e.code))?.longDescription || row?.ei_value

        return (out)
      }
    },
    getColumn({ id: 'area', header: 'HeaderArea', code: 'COURSE_AREA', columnIndex: 1 }),
    getColumn({ id: 'race', header: 'HeaderRace', code: 'UNIT_NUM', className: 'text-end', headerClassName: 'text-end', columnIndex: 2 }),
    getColumn({ id: 'windDir', header: 'HeaderWindDir', code: 'WIND_DIR', className: 'text-end', headerClassName: 'text-end', columnIndex: 3 }),
    getColumn({ id: 'windSpeed', header: 'HeaderWindSpeed', code: 'WIND_SPEED', className: 'text-end', headerClassName: 'text-end', columnIndex: 4 }),
    getColumn({ id: 'status', header: 'HeaderRaceStatus', code: 'STATUS', columnIndex: 5 }),
    getColumn({ id: 'startTime', header: 'HeaderStartTime', code: 'START_TIME', className: 'text-end', headerClassName: 'text-end', columnIndex: 6 }),
    getColumn({ id: 'sailed', header: 'HeaderCourse2BSalled', code: 'COURSE_SAILED', className: 'text-center', headerClassName: 'text-center', columnIndex: 7 }),
    getColumn({ id: 'leg', header: 'HeaderCurrentLeg', code: 'LEG_CURRENT', className: 'text-center', headerClassName: 'text-center', columnIndex: 8 }),
    getColumn({ id: 'next', header: 'HeaderNextRaceEST', code: 'EST_NEXT_START', className: 'text-end', headerClassName: 'text-end', columnIndex: 9 }),
    getColumn({ id: 'limit', header: 'HeaderProtestTimeLimit', code: 'PROTEST_TIME', className: 'text-end', headerClassName: 'text-end', columnIndex: 10 })
  ])

  let lastUpdated = currentData?.results?.currentExtendedInfos?.find(ei => ei.ei_code === 'DATE')?.ei_value
  let tableData = currentData?.results?.currentExtendedInfos?.filter(ei => ei.ei_code === 'EVENT').sort((a, b) => b.ei_pos - a.ei_pos) || []

  if (!tableData || tableData?.length === 0) { return <NotAvailable label={'LabelNoDataDailyComponent'} /> }
  const formatDateTime = getDateTimeFormat('OrdinalDateTimeLong');
  return (
    <div className='mirs-page-container'>
      <MirsTable
        id={`mirs-table-competition-status`}
        caption={
          <>
            <DateTime format={formatDateTime} datetime={lastUpdated} />
          </>
        }
        data={tableData}
        columns={tableColumns}
        showLoading={false}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '4,3,3' : '10'}
        showNavExtendedData={true}
        colIndex={1}
      />
    </div>
  )
}

export default CompetitionStatus